import { parsePhoneNumberFromString } from "libphonenumber-js";

const rEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function NumberValidators(values: any) {
  let errors: any = {};

  if (!values.description) {
    errors.description = "La Descripción de los daños es requerido";
  }

  if (values.description && values.description.length > 1333) {
    errors.description =
      "La descripción de los daños no debe superar los 1333 caracteres";
  }

  if (
    values.identification_number &&
    !/^\d+$/.test(values.identification_number)
  ) {
    errors.identification_number = "Solo debes incluir números";
  }

  if (values.year && !/^\d+$/.test(values.year)) {
    errors.year = "Solo debes incluir números";
  }

  if (values.contact_phone && !/^\d+$/.test(values.contact_phone)) {
    errors.contact_phone = "Solo debes incluir números";
  }

  const phoneNumber = parsePhoneNumberFromString(values.contact_phone, "AR");

  if (values.contact_phone && !phoneNumber?.isValid()) {
    errors.contact_phone =
      "El número telefónico ingresado es inválido (prefijo + número -sin el 15- )";
  }

  if (values.email && !rEmail.test(values.email)) {
    errors.email = "El email ingresado es inválido";
  }

  if (
    values.identification_number &&
    values.identification_number.length > 15
  ) {
    errors.identification_number = "El número de identificación es inválido";
  }

  if (
    values.identification_number &&
    !/^\d+$/.test(values.identification_number)
  ) {
    errors.identification_number = "Solo debes incluir números";
  }

  if (values.identification_number && values.identification_number[0] === "0") {
    errors.identification_number =
      "No incluyas el 0 al inicio de tu número de documento";
  }

  return errors;
}
